module.exports = __webpack_public_path__ + "img/Base3.eb24fd81.svg";